import { ChainId, Currency, ETHER } from '@uniswap/sdk'

type NativeCurrencyInfo = {
  symbol: string
  name: string
  logoURI?: string
}

const NATIVE_CURRENCY_BY_CHAIN: { [chainId in ChainId]?: NativeCurrencyInfo } = {
  [ChainId.TURING]: { symbol: 'TURING', name: 'TURING', logoURI: 'https://turingchain.net/logo.svg' }
}

export function getNativeCurrencySymbol(chainId?: ChainId): string {
  return (chainId && NATIVE_CURRENCY_BY_CHAIN[chainId]?.symbol) || 'ETH'
}

export function getNativeCurrencyName(chainId?: ChainId): string {
  return (chainId && NATIVE_CURRENCY_BY_CHAIN[chainId]?.name) || 'Ether'
}

export function getNativeCurrencyLogoURI(chainId?: ChainId): string | undefined {
  return chainId ? NATIVE_CURRENCY_BY_CHAIN[chainId]?.logoURI : undefined
}

export function getCurrencySymbol(currency?: Currency | null, chainId?: ChainId): string | undefined {
  if (!currency) return undefined
  if (currency === ETHER) return getNativeCurrencySymbol(chainId)
  return currency.symbol
}

export function getCurrencyName(currency?: Currency | null, chainId?: ChainId): string | undefined {
  if (!currency) return undefined
  if (currency === ETHER) return getNativeCurrencyName(chainId)
  return currency.name
}
